import React from 'react'
import { Field } from 'react-final-form'

import { TritonTextField } from 'src/components/Forms/TextField'
import {
  BoldSpan,
  DoubleInputGrid,
  FlexDiv,
  GeneralContainer
} from '../../shared'

const ArizonaMethodsPart3 = (): JSX.Element => {
  return (
    <GeneralContainer>
      <p style={{ marginBottom: '0px' }}>
        {`Identify the service line investigation methods your system used to
        prepare the inventory (check all that apply). If a water system chooses
        an investigation method not specified by the state under 40 CFR
        §141.84(a)(3)(iv), state approval is required. `}
        <BoldSpan>
          Note that investigations are not required by the LCRR but can be used
          by systems to assess accuracy of historical records and gather
          information when service line material is unknown.
        </BoldSpan>
      </p>
      <DoubleInputGrid>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Visual Inspection at the Meter Pit"
          />
          <label>Visual Inspection at the Meter Pit</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="CCTV Inspection at Curb Box - External"
          />
          <label>CCTV Inspection at Curb Box - External</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="CCTV Inspection at Curb Box - Internal"
          />
          <label>CCTV Inspection at Curb Box - Internal</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Water Quality Sampling - Targeted"
          />
          <label>Water Quality Sampling - Targeted</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Water Quality Sampling - Flushed"
          />
          <label>Water Quality Sampling - Flushed</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Water Quality sampling - Sequential"
          />
          <label>Water Quality sampling - Sequential</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Water Quality Sampling - Other"
          />
          <label>Water Quality Sampling - Other</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Mechanical Excavation"
          />
          <label>Mechanical Excavation</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Vacuum Excavation"
          />
          <label>Vacuum Excavation</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Interpolation"
          />
          <label>Interpolation</label>
        </FlexDiv>
        <FlexDiv>
          <Field
            component="input"
            name="inventoryMethodsPart3Q1ServiceLineInvestigationChoices"
            type="checkbox"
            value="Other"
          />
          <label>Other</label>
        </FlexDiv>
      </DoubleInputGrid>
      <Field<string>
        component={TritonTextField}
        label="If “interpolation”, were the following used to properly interpolate? Selected area is a homogenous community with less than 1,500 service connections AND two or more similar factors including: construction year, location, or contractor/developer. ADEQ requires 20 percent of the total service lines (randomly selected) in the homogenous area to be visually or physically investigated with a 95% confidence rate to produce accurate results for the area."
        name="inventoryMethodsPart3Q2PredictiveModelingExplanation"
        textarea
      />
      <Field<string>
        component={TritonTextField}
        label="If other please explain:"
        name="inventoryMethodsPart3Q1ServiceLineInvestigationOtherExplanation"
        textarea
      />
    </GeneralContainer>
  )
}

export default ArizonaMethodsPart3
